/**
 * Registry der eigenen Markdown-Container ("Callouts").
 *
 * Einen neuen einfachen Callout ergänzen = ein Eintrag hier. Beispiel im Text:
 *
 *   ::: info Wichtiger Hinweis
 *   Das ist der Inhalt.
 *   :::
 *
 * Spezielle Container (z. B. `collapse`, später interaktive) werden in
 * src/markdown/index.ts separat registriert.
 */

export interface CalloutDef {
  /** Name des Containers (= Schlüsselwort im Markdown). */
  name: string;
  /** Standard-Überschrift, falls keine im Markdown angegeben ist. */
  title: string;
}

export const callouts: CalloutDef[] = [
  { name: "info", title: "Info" },
  { name: "warning", title: "Achtung" },
  { name: "example", title: "Beispiel" },
  { name: "definition", title: "Definition" },
  { name: "summary", title: "Zusammenfassung" },
  { name: "tafelbild", title: "Tafelbild" },
];
